// メニューの開閉制御

export default function displayMenu() {
  var $spMenu = $('.js-menu');
  var $menuBtn = $('.js-menuBtn');

  $menuBtn.on('click', function() {
    $spMenu.toggleClass('is-open').slideToggle();
    $menuBtn.children().toggleClass('is-open');
  });
}


// WEBPACK FOOTER //
// ./js/module/displayMenu.js